/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { InfoItem } from '@molecules';
import { pluralize } from '@utils';

import { FORM_FIELD } from './constants';

const Item = ({ className, module, previewImg, errors }) => (
  <InfoItem.WithError
    error={errors}
    size="large"
    image={previewImg}
    description={pluralize(module.content[FORM_FIELD.ATHLETES.name].length, 'athlete')}
  >
    Featured Athletes
  </InfoItem.WithError>
);

export default Item;
